<template>
  <b-modal
    ref="modal"
    static
    :visible="show"
    :title="modalTitle"
    header-bg-variant="light"
    @hidden="resetForm"
    @close="close"
    @cancel="close"
    @ok.prevent="handleSubmit"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    centered
  >
    <b-form @submit.prevent="handleSubmit" ref="form">
      <b-form-group
        label="Tên mức độ lỗi:"
        label-for="name-input"
        :state="isValidName"
        :invalid-feedback="nameInvalidFeedback"
      >
        <b-form-input
          id="name-input"
          v-model="form.name"
          :state="isValidName"
          required
          placeholder="Nhập tên mức độ lỗi"
          maxlength="255"
          :disabled="isSubmitting"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="Mô tả:"
        label-for="description-input"
        :state="isValidDescription"
        :invalid-feedback="descriptionInvalidFeedback"
      >
        <b-form-textarea
          id="description-input"
          v-model="form.description"
          :state="isValidDescription"
          placeholder="Nhập mô tả về mức độ lỗi"
          rows="3"
          max-rows="6"
          maxlength="500"
          :disabled="isSubmitting"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group label-for="active-input">
        <b-form-checkbox
          id="active-input"
          v-model="form.isActive"
          :disabled="isSubmitting"
          switch
        >
          {{ form.isActive ? 'Hoạt động' : 'Không hoạt động' }}
        </b-form-checkbox>
      </b-form-group>
    </b-form>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
        Hủy bỏ
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting || !isFormValid"
        @click="handleSubmit"
      >
        <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
        {{ isEdit ? 'Cập nhật' : 'Thêm mới' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { ErrorSeverityService } from './service/error-severity.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

export default {
  name: 'ErrorSeverityFormModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    errorSeverity: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: '',
        description: '',
        isActive: true,
      },
      validationErrors: {
        name: '',
        description: '',
      },
    };
  },
  computed: {
    modalTitle() {
      return this.isEdit
        ? `Chỉnh sửa mức độ lỗi: ${this.errorSeverity?.name || ''}`
        : 'Thêm mới mức độ lỗi';
    },
    isValidName() {
      return this.validationErrors.name ? false : null;
    },
    isValidDescription() {
      return this.validationErrors.description ? false : null;
    },
    nameInvalidFeedback() {
      return this.validationErrors.name;
    },
    descriptionInvalidFeedback() {
      return this.validationErrors.description;
    },
    isFormValid() {
      return !!this.form.name;
    },
  },
  watch: {
    errorSeverity(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.errorSeverity) {
        this.form = {
          ...this.form,
          ...this.errorSeverity,
        };
      }
    },
    resetForm() {
      this.form = {
        name: '',
        description: '',
        isActive: true,
      };
      this.validationErrors = {
        name: '',
        description: '',
      };
    },
    validateForm() {
      this.validationErrors = {
        name: '',
        description: '',
      };

      if (!this.form.name.trim()) {
        this.validationErrors.name = 'Tên mức độ lỗi không được để trống';
      }

      return !this.validationErrors.name;
    },
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = {
        name: this.form.name.trim(),
        description: this.form.description.trim(),
        isActive: this.form.isActive,
      };

      const request = this.isEdit
        ? ErrorSeverityService.update(this.errorSeverity.id, payload)
        : ErrorSeverityService.create(payload);

      request
        .then((response) => {
          if (response.data.status === 200) {
            const message = this.isEdit
              ? 'Cập nhật mức độ lỗi thành công!'
              : 'Thêm mới mức độ lỗi thành công!';

            makeToastSuccess(message);
            this.$emit('error-severity-saved', response.data.data);
          } else {
            makeToastFaile(
              response.data.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .catch((error) => {
          console.error('Error saving error severity:', error);

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((key) => {
              if (key in this.validationErrors) {
                this.validationErrors[key] = errors[key];
              }
            });
          } else {
            makeToastFaile(
              error.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .finally(() => {
          this.isSubmitting = false;
          if (!Object.values(this.validationErrors).some((v) => v)) {
            this.close();
          }
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>